import { useState } from "react";
import { Wallet } from "lucide-react";
import { toast } from "sonner";
import { connectWallet, switchToChain, shortAddr } from "../../lib/web3";
import { useI18n } from "../../i18n/I18nProvider";
import { track } from "../../lib/analytics";

export function WalletButton({ compact = false }) {
  const { t } = useI18n();
  const [state, setState] = useState({ status: "idle" });
  const [busy, setBusy] = useState(false);

  const onConnect = async () => {
    setBusy(true);
    track("wallet_connect_attempt");
    const r = await connectWallet();
    setBusy(false);
    setState(r);
    const msg = { no_provider: t("wallet.noProvider"), rejected: t("wallet.rejected"), wrong_network: t("wallet.wrongNetwork"), error: t("wallet.error"), disconnected: t("wallet.error") }[r.status];
    if (msg) toast(msg);
  };

  if (state.status === "connected" || state.status === "wrong_network") {
    return (
      <div className="flex items-center gap-2" data-testid="wallet-status">
        <span className={`rounded-full px-3 py-1.5 text-xs font-bold ${state.status === "connected" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-800"}`}>
          {state.status === "connected" ? `${t("wallet.connected")} ${shortAddr(state.account)}` : t("wallet.wrongNetwork")}
        </span>
        {state.status === "wrong_network" && <button data-testid="wallet-switch-btn" onClick={async () => (await switchToChain()) && onConnect()} className="btn-pill btn-ghost text-xs">{t("wallet.switch")}</button>}
        <button data-testid="wallet-disconnect-btn" onClick={() => setState({ status: "idle" })} className="btn-pill btn-ghost text-xs">{t("wallet.disconnect")}</button>
      </div>
    );
  }
  return (
    <button data-testid="wallet-connect-btn" onClick={onConnect} disabled={busy} className={`btn-pill btn-ghost whitespace-nowrap ${compact ? "text-sm" : ""}`}>
      <Wallet className="h-4 w-4" aria-hidden />{t("wallet.connect")}
    </button>
  );
}
